import colorSyntax from "@toast-ui/editor-plugin-color-syntax";
import "@toast-ui/editor/dist/toastui-editor.css";
import { Editor } from "@toast-ui/react-editor";
import { useMemo, useRef, useState } from "react";
import { uploadFilesAsync } from "src/api/file/file-api";
import { useApiOperation } from "src/api/hooks";
import { Modal } from "src/api/public-types";
import useCustomLinkAction from "src/hooks/useCustomLinkAction";
import { BaseModal } from "./BaseModal";

type Props = {
  value?: string;
  onChange?: (htmlContent?: string) => void;
  errorText?: string;
  height?: string;
  width?: string;
};

const s3Url = process.env.REACT_APP_S3_BASEURL;

const MarkdownEditor = (props: Props) => {
  const editorRef = useRef<Editor>(null);

  const { tooltip: linkPreviewTooltip, onEditorLoad } = useCustomLinkAction(editorRef);

  const [alertModal, setAlertModal] = useState<Modal>({ isOpen: false });

  const colorSyntaxOptions = useMemo(() => {
    return {
      preset: ["#FF695B", "#26A687", "#FFD335", "#191919", "#525252", "#767676", "#999999", "#DBDBDB", "#E0E0E0", "#F2F4F6", "#F8F8FA", "#FFFFFF"],
    };
  }, []);

  // 파일 업로드 api hook
  const { executeAsync: postImageFile } = useApiOperation(uploadFilesAsync, {
    noErrorModal: true,
  });

  const onChangeValue = () => {
    const editorInstance = editorRef.current?.getInstance();

    // editor value를 markdown 형식으로 onChnage
    // const markDown = editorInstance?.getMarkdown();

    // editor value를 html 형식으로 onChnage > harry 수정
    // 줄바꿈 해서 저장 시 markDown 형식이 줄바꿈을 적용하지 않음
    const htmlContent = editorInstance?.getHTML();
    if (props.onChange) {
      props.onChange(htmlContent);
    }
  };

  return (
    <div className="base-markdown">
      {/* @ts-ignore*/}
      <Editor
        ref={editorRef}
        initialValue={props?.value || " "}
        previewStyle="tab"
        height={props.height || "600px"}
        initialEditType="wysiwyg"
        useCommandShortcut={true}
        // plugins={[colorSyntax]}
        plugins={[[colorSyntax, colorSyntaxOptions]]}
        onLoad={onEditorLoad}
        onChange={onChangeValue}
        usageStatistics={false}
        hooks={{
          addImageBlobHook: async (blob, callback) => {
            // 파일 업로드시 S3 로 업로드 하는 기능 (현재 비활성화)
            const formData = new FormData();
            formData.append("file", blob);
            const response = await postImageFile({
              file: formData,
              type: "public",
            });
            callback(`${s3Url + (response.data.data.media.key || "")}`);
          },
        }}
      />
      {linkPreviewTooltip}
      {props.errorText && <p className="validation-text">{props.errorText}</p>}

      <>
        {alertModal.isOpen && (
          <BaseModal isOpen={alertModal.isOpen} btnRightTitle="확인" onClick={() => setAlertModal({ isOpen: false })}>
            <p className="pre-formatted">{alertModal.message}</p>
          </BaseModal>
        )}
      </>
    </div>
  );
};

export default MarkdownEditor;
